// @mui
import { List, Stack } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
//
import { NavSectionProps } from '../types';
import { StyledSubheader } from './styles';
import NavList from './NavList';
import { useAuthContext } from '../../../auth/useAuthContext';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
  const { translate } = useLocales();
  const { user } = useAuthContext();

  const currentRole = user?.role;

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.subheader.title || group.items[0].title;
        const isAllowed = group.subheader.roles
          ? group.subheader?.roles?.includes(currentRole)
          : true;

        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.subheader.title && isAllowed && (
              <StyledSubheader disableSticky>{`${translate(
                group.subheader.title
              )}`}</StyledSubheader>
            )}

            {group.items.map((list) => (
              <NavList
                key={list.title + list.path}
                data={list}
                depth={1}
                hasChild={!!list.children}
              />
            ))}
          </List>
        );
      })}
    </Stack>
  );
}
